import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GenerateLifeStatus360ReportRequest {
  benefitBeginDate: string;
}

export interface GenerateLifeStatus360ReportResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class LifeStatus360ReportService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Generate Life Status 360 Export
   * @param request Contains benefitBeginDate
   * @returns Observable with token
   */
  generateLifeStatus360Export(
    request: GenerateLifeStatus360ReportRequest
  ): Observable<GenerateLifeStatus360ReportResponse> {
    return this.httpClient.post<GenerateLifeStatus360ReportResponse>(
      `${environment.apiUrl}/report/lifestatus-360-report/generate-export`,
      request
    );
  }

  /**
   * Download Life Status 360 Export using token
   * @param token Token received from generate export
   * @returns Observable with file blob
   */
  downloadLifeStatus360Export(token: string): Observable<Blob> {
    return this.httpClient.get(
      `${environment.apiUrl}/report/lifestatus-360-report/download-export?token=${token}`,
      { responseType: 'blob' }
    );
  }
}
